const React = require('react');
const withReDelay = require('mn-utils/withReDelay');

const {HeadCellAdmin, HeadCellAdminFilter} = require('../../../../TableHeadCell/components/HeadCellAdmin');
const {
  IntervalFilterAdmin,
} = require('../../../../IntervalFilterCustom');
const {STATUSES_FILTER_TABLE_HEAD} = require("../../../../../../constants/statusesTrx");

module.exports = ({self, filter$, items, report, showCustomer, fullSize}) => {
  const state = self.state;

  const update = withReDelay(self.update, 1000);
  function handleChangeFilter(filter) {
    filter$.emit({
      ...state.filter,
      ...filter,
    });
    update();
  }

  const filter = state.filter;

  return (
    <>
      <IntervalFilterAdmin
        className="mt20 m0@m"
        data={filter}
        sort={state.sort}
        onChange={handleChangeFilter}
        report={report}
        update={self.update}
        // selectFilters={[STATUSES_FILTER_SELECT]}
        search={{
          className: 'wmin180 fx1',
          placeholder: 'Search',
        }}
        // additionalBtns={(
        //   <div>
        //     <BtnTableGlobal
        //       icon={EditIcon}
        //       text="start"
        //       onClick={() => openPopupNuveiBulkEdit(update)}
        //     />
        //   </div>
        // )}
      />
      <div className={`rlv hmin480 h100vh-440 h100vh-315@m2 h100vh-325.fullSize h100vh-210@m2.fullSize` + (fullSize ? ' fullSize' : '')}>
        <div className="ovxA abs s">
          <div className="wmin1665 rlv h">
            <div className="w abs bgE layoutRow aiStretch">
              <HeadCellAdmin className="wmin185 fx1">
                Internal Transaction ID
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Retailer Order ID
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Merchant Name
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Date and Time
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Amount
              </HeadCellAdmin>
              {showCustomer && (
                <HeadCellAdmin className="wmin185 fx1">
                  Customer
                </HeadCellAdmin>
              )}
              <HeadCellAdmin className="wmin185 fx1">
                Payment Method
              </HeadCellAdmin>
              <HeadCellAdmin className="wmin185 fx1">
                Payment Gateway
              </HeadCellAdmin>
              {/*<HeadCellAdminFilter*/}
              {/*  className="wmin185 fx1"*/}
              {/*  filters={PAYMENT_METHODS_FILTER_TABLE_HEAD}*/}
              {/*  handleChangeFilter={handleChangeFilter}*/}
              {/*  self={self}*/}
              {/*>*/}
              {/*  Payment Method*/}
              {/*</HeadCellAdminFilter>*/}
              {/*<AdminCell className="wmin185 fx1">*/}
              {/*  Type*/}
              {/*</AdminCell>*/}
              <HeadCellAdminFilter
                className="wmin185 fx1"
                filters={STATUSES_FILTER_TABLE_HEAD}
                handleChangeFilter={handleChangeFilter}
                self={self}
              >
                Status
              </HeadCellAdminFilter>
            </div>
            <div className="abs sh st45 sb c0>.CircularProgress">
              {items}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
